import { tv } from "../../variants/tv.js";
const cardAsVariants = {
    div: {
        cardSlot: 'text-center'
    },
    button: {
        cardSlot: ''
    }
};
const cardAs = Object.keys(cardAsVariants);
const cardVariants = tv({
    slots: {
        cardContainerSlot: '',
        cardSlot: 'bg-primary-1 relative w-full p-3 transition-shadow hover:cursor-pointer active:shadow-sm',
        contentSlot: ''
    },
    variants: {
        as: cardAsVariants,
        size: {
            sm: {
                cardSlot: 'rounded-lg shadow-sm hover:shadow-lg'
            },
            md: {
                cardSlot: 'rounded-xl shadow-md hover:shadow-xl'
            }
        }
    },
    defaultVariants: {
        as: 'button',
        size: 'md',
        topSubPanelEmphasis: 'none',
        bottomSubPanelEmphasis: 'none'
    }
});
export { cardAs, cardAsVariants, cardVariants };
